import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Menu } from '@material-ui/icons';
import { IconButton, Drawer } from '@material-ui/core';
import icon from './../../assets/svg/saltoLogo.svg'
import logoutIcon from './../../assets/svg/logout.svg'
import './Header.css';
import { AuthContext } from '../../auth/AuthHandler';

const Header = () => {

  const authCtx = useContext(AuthContext)

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  const { mobileView, drawerOpen } = state;

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 792
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  const displayDesktop = () => {
    return (
      <div className="header">
      <Link to="/">
        <img className="icon" src={icon} alt="SALTO"/>
        <h1 className="header-title">Release tracker</h1>
      </Link>
      <div className="header-menu">
        <div className="header-item-user"><span className="user">User</span></div>
        <div className="header-item-email">
          <div className="email">{authCtx.email}</div>
          <img className="logout" src={logoutIcon} alt="Logout" onClick={() => authCtx.logout()}/>
        </div>
      </div>
    </div>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    return (
      <div className="header">
        <IconButton
          {...{
            edge: "start", 
            color: "inherit", 
            "aria-label": "menu", 
            "aria-haspopup":"true", 
            onClick: handleDrawerOpen
          }}
        >
          <Menu style={{paddingLeft: 20}} />
        </IconButton>
        <Drawer
        {...{
          anchor: 'left', 
          open: drawerOpen, 
          onClick: handleDrawerClose
        }}
        >
          <div className="drawerContainer">
            <div className="header-menu-mobile">
              <Link to="/">
                <img src={icon} alt="SALTO"/>
              </Link>
              <div className="header-item-user"><span className="user">User</span></div>
              <div className="header-item-email">
                <div className="email">{authCtx.email}</div>
                <img className="logout" src={logoutIcon} alt="Logout" onClick={() => authCtx.logout()}/>
              </div>
            </div>
          </div>
        </Drawer>
          <Link to="/">
            <h1 className="header-title-mobile">Release tracker</h1>
            <img className="icon" src={icon} alt="SALTO"/>
          </Link>
      </div>
    );
  };


  return (
      <div className='header'>
        {mobileView ? displayMobile() : displayDesktop()}
      </div>
  );
}

export default Header;
